module.exports = __webpack_public_path__ + "img/ic_logo_oecd_40dp.ec7fae4e.svg";